<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.rents'), $t('text.list')]">
        <el-button
          v-if="Permit.canActionsChargeEdition('rentManage')"
          type="success"
          size="mini"
          @click="$router.push('/normal/rents/new')"
          >+ {{ $t("text.create") }}{{ $t("menu.rents") }}</el-button
        >
        <el-button
          v-if="Permit.canActionsChargeEdition('rentManage')"
          type="primary"
          size="mini"
          @click="$router.push('/normal/rents/new-clean')"
          >+ {{ $t("text.create") }}{{ $t("menu.cleans") }}</el-button
        >
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.keyword"
            :placeholder="$t('placeholder.serialNoInnerSerialNoCustomer')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          />
        </el-form-item>
        <el-form-item v-if="!Permit.isFreeEdition()">
          <el-select
            size="small"
            v-model="searchForm.shopId"
            :placeholder="$t('menu.shops')"
            filterable
            clearable
          >
            <el-option
              v-for="shop in shops"
              :key="shop.id"
              :label="shop.name"
              :value="shop.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="createAt"
            :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="rentAt"
            :start-placeholder="$t('rules.startAt', [$t('rent.rentAt')])"
            :end-placeholder="$t('rules.endAt', [$t('rent.rentAt')])"
          />
        </el-form-item>
         <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.remark"
            :placeholder="$t('text.remark')"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>

    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">{{
                  $t("action.downLoadChecked")
                }}</el-dropdown-item>
                <el-dropdown-item command="search">{{
                  $t("action.downLoadSearch")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="selectRecord"
        @checkbox-all="selectAllRecords"
        :checkbox-config="{ reserve: true }"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        :span-method="mergeMethod"
        :loading="loading"
        id="bargainsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        :row-class-name="calculateBgColor"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <span v-if="!row.isMerge">
              <thumbnail :images="row.images" />
            </span>
            <div v-else>
              <span class="float-left">
                <div
                  class="tag-type mgr5"
                  v-if="row.type == 'rent'"
                  style="
                    background-color: #f0f9eb;
                    border: 1px solid #e1f3d8;
                    color: #67c23a;
                  "
                >
                  {{ $t("menu.rents") }}
                </div>
                <div
                  class="tag-type mgr5 el-tag--warning"
                  v-if="row.type == 'clean'"
                  style="
                    background-color: #fdf6ec;
                    border: 1px solid #faecd8;
                    color: #e6a23c;
                  "
                >
                  {{ $t("menu.cleans") }}
                </div>
                <span class="blue mgr5" @click="showRent(row)">
                  {{ row.serialNo }}
                </span>
                <span v-if="row.type == 'rent'">
                  <span class="font10 mgr5">
                    {{ $t("text.total") }}:
                    {{ row.amount | currency }}
                  </span>

                  <span class="font10 mgr5">
                    {{ $t("bargain.receive") }}:
                    {{ row.payAmount | currency }}
                  </span>

                  <span v-if="row.differAmount > 0" class="font10 red mgr5">
                    {{ $t("bargain.differ") }}:
                    {{ row.differAmount | currency }}
                  </span>
                  <span v-if="row.differAmount == 0" class="font10 green mgr5">
                    {{ $t("bargain.settled") }}
                  </span>
                  <span v-if="row.differAmount < 0" class="font10 orange">
                    {{ $t("bargain.leave") }}:{{ -row.differAmount | currency }}
                  </span>
                </span>
                {{ $t("rent.rentAt") }}：{{ row.startAt }} ～
                {{ row.endAt }}
              </span>

              <span class="float-right font10">
                <span v-if="row.type == 'rent'">
                  {{ $t("menu.customers") }}：{{ row.customerName }}&nbsp;
                </span>

                {{ $t("text.owner") }}:{{ row.ownerName }} {{ row.shopName }}
              </span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="150"
        >
          <template v-slot="{ row }">
            {{ row.serialNo }}
            <div>
              <state-label :state="row.workflowState">
                {{ $t("rentStates." + row.workflowState) }}
              </state-label>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}

            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="price"
          :title="$t('rentItem.price')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.price | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="60"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit || "" }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="outName"
          :title="$t('rentItem.outName')"
          min-width="70"
        >
          <template v-slot="{ row }">
            {{ row.outName }}
            <div class="font10">{{ row.outAt }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="finishName"
          :title="$t('rentItem.finishName')"
          min-width="70"
        >
          <template v-slot="{ row }">
            {{ row.finishName }}
            <div class="font10">{{ row.finishAt }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          min-width="110"
        />
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="10"
              type="richText"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="Permit.canActionsChargeEdition('rentManage')"
          field="action"
          :title="$t('text.action')"
          width="130"
        >
          <template v-slot="{ row, rowIndex }">
            <template v-if="row.isMerge">
              <el-dropdown>
                <a class="el-dropdown-link small-link">
                  {{ $t("action.print") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </a>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div
                      class="font10"
                      @click="printRentSlip(row, 'printRentSlipDiv')"
                    >
                      <span v-if="row.type == 'rent'">
                        {{ $t("action.printRent") }}
                      </span>
                      <span v-if="row.type == 'clean'">
                        {{ $t("action.printClean") }}
                      </span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-for="(pt, index) of printTemplatesRentSlip"
                    :key="index"
                    :divided="index == 0 ? true : false"
                  >
                    <div class="font10" @click="printRentSlip(row, pt)">
                      {{ pt.name }}
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown class="mgl10">
                <a class="el-dropdown-link small-link">
                  {{ $t("text.more") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </a>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div
                      class="font10"
                      @click="
                        $router.push(
                          '/normal/rents/new-item/' +
                            row.id +
                            '?type=' +
                            row.type
                        )
                      "
                    >
                      {{ $t("action.addProducts") }}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div
                      class="font10"
                      @click="distributiveOwner(row, rowIndex)"
                    >
                      {{ $t("action.distributiveOwner") }}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="row.type == 'rent'">
                    <div class="font10" @click="addPayment(row, rowIndex)">
                      {{ $t("action.addReceiveAndPayment") }}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="canEditRent(row)">
                    <div class="font10" @click="editRent(row, rowIndex)">
                      {{ $t("text.edit") }}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="canDelRent(row)">
                    <div class="font10" @click="deleteRent(row)">
                      {{ $t("text.delete") }}
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template v-else>
              <el-button
                v-if="row.workflowState === 'newly'"
                type="text"
                size="mini"
                @click="editRentItem(row, rowIndex)"
              >
                {{ $t("text.edit") }}
              </el-button>
              <el-button
                v-if="row.workflowState === 'newly'"
                type="text"
                size="mini"
                @click="deleteItem(row)"
                >{{ $t("text.delete") }}</el-button
              >
              <el-button
                v-if="row.workflowState == 'newly'"
                type="text"
                size="mini"
                @click="outItem(row, rowIndex)"
                >{{ $t("action.stockOut") }}</el-button
              >
              <el-button
                v-if="row.workflowState == 'outed'"
                type="text"
                size="mini"
                @click="finishItem(row, rowIndex)"
                >{{ $t("action.finishDone") }}</el-button
              >
            </template>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span> 条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <!-- ===== -->
    <drawer
      :title="$t('text.view', [$t('menu.rents')])"
      :visible.sync="showRentDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-rent :id="currentRowRentId" @updateInfo="showRentUpdated" />
    </drawer>

    <drawer
      :title="$t('text.edit', [$t('menu.rents')])"
      :visible.sync="editRentDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <edit-rent :id="currentRowRentId" @updateInfo="rentUpdated" />
    </drawer>

    <!-- 分配拥有人 -->
    <el-dialog
      :title="$t('action.distributiveOwner')"
      :close-on-click-modal="false"
      :visible.sync="distributiveOwnerDF"
      width="30%"
    >
      <el-form ref="distributiveOwnerObjForm" :model="distributiveOwnerObj">
        <el-form-item
          :prop="'ownerId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.owner')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="distributiveOwnerObj.ownerId"
            clearable
            filterable
          >
            <el-option
              v-for="user in usersFilterValid"
              :key="user.id"
              :label="user.name"
              :value="user.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="distributiveOwnerDoing"
          size="small"
          @click="distributiveOwnerSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="distributiveOwnerDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 收款 -->
    <el-dialog
      :title="$t('action.addReceiveAndPayment')"
      :close-on-click-modal="false"
      :visible.sync="addPaymentDF"
      width="30%"
    >
      <el-form
        ref="addPaymentObjForm"
        :model="addPaymentObj"
        label-width="60px"
      >
        <el-row>
          <el-col :span="24" class="center">
            <el-radio-group v-model="addPaymentObj.type" size="small">
              <el-radio-button label="receivables">
                {{ $t("action.payment") }}
              </el-radio-button>
              <el-radio-button label="return">
                {{ $t("action.paymentReturn") }}
              </el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-form-item
          :label="$t('payment.total')"
          :prop="'total'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('payment.total')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="addPaymentObj.total"
            @blur="blurJudgeBalance"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('payment.payMethod')"
          :prop="'payMethodId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('payment.payMethod')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="addPaymentObj.payMethodId"
            clearable
            filterable
            @change="blurJudgeBalance"
          >
            <el-option
              v-for="payMethod in payMethods"
              :key="payMethod.id"
              :label="payMethod.name"
              :value="payMethod.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('payment.paidAt')"
          :prop="'paidAt'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('payment.paidAt')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            size="small"
            v-model="addPaymentObj.paidAt"
            type="date"
            style="width: 100%"
            :picker-options="pickerOptionsFiveDays"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('payment.explain')" :prop="'explain'">
          <el-input size="small" v-model.trim="addPaymentObj.explain" />
        </el-form-item>
        <el-form-item :label="$t('payment.voucher')" :prop="'voucher'">
          <dropzone v-model="addPaymentObj.voucher" multiple />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="addPaymentDoing"
          size="small"
          @click="addPaymentSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addPaymentDF = false">
          {{ $t("text.close") }}
        </el-button>
      </div>
    </el-dialog>

    <div id="printRentSlipDiv" style="display: none">
      <div style="width: 100%">
        <div style="text-align: center; font-size: 18px">
          {{ Permit.currentTenant().name }}
          <span v-if="printRent.type == 'rent'">{{
            $t("rent.rentsSlip")
          }}</span>
          <span v-if="printRent.type == 'clean'">{{
            $t("clean.cleansSlip")
          }}</span>
        </div>
        <div style="text-align: center; font-size: 16px">
          {{ printRent.shopName }}&nbsp;&nbsp;{{ printRent.ownerName }}
        </div>
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #dfe5ec;
            text-align: left;
            margin-bottom: 20px;
            padding: 5px;
          "
        >
          <tr
            style="
              border: 1px solid #dfe5ec;
              text-align: left;
              padding-left: 5px;
            "
          >
            <td style="border: 1px solid #dfe5ec; padding: 5px" colspan="10">
              {{ $t("bargain.customerName") }}：{{
                printRent.customerName
              }}
              &nbsp;&nbsp;&nbsp;&nbsp; {{ $t("bargain.customerPhone") }}：{{
                printRent.customerPhone
              }}
              &nbsp;&nbsp;&nbsp;&nbsp; {{ $t("bargain.customerAddress") }}：
              <span v-if="printRent.customerCountry != null">{{
                $t("countries." + printRent.customerCountry)
              }}</span>
              {{ printRent.customerProvince || ""
              }}{{ printRent.customerCity || ""
              }}{{ printRent.customerAddress || "" }}
              <span style="float: right"
                >{{ $t("rent.rentAt") }}：{{ printRent.startAt }} ～
                {{ printRent.endAt }}</span
              >
            </td>
          </tr>

          <tr style="border: 1px solid #dfe5ec; text-align: center">
            <td style="border: 1px solid #dfe5ec; width: 30px; padding: 5px">
              #
            </td>
            <td style="border: 1px solid #dfe5ec; width: 80px">
              {{ $t("product.images") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 120px">
              {{ $t("rent.serialNo") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              {{ $t("product.productNo") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 60px">
              {{ $t("product.color") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 60px">
              {{ $t("product.size") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 60px">
              {{ $t("text.quantity") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 80px">
              {{ $t("rentItem.price") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 80px">
              {{ $t("order.subtotal") }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 80px">
              {{ $t("text.remark") }}
            </td>
          </tr>
          <tr
            v-for="(item, itemIndex) in printRent.rentItems"
            :key="itemIndex"
            style="border: 1px solid #dfe5ec; text-align: center"
          >
            <td style="border: 1px solid #dfe5ec; width: 30px; padding: 5px">
              {{ itemIndex + 1 }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 80px">
              <img :src="item.firstImage" style="width: 50px" />
            </td>
            <td style="border: 1px solid #dfe5ec; width: 80px">
              {{ item.serialNo }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 80px">
              {{ item.productNo }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 50px">
              {{ item.color }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 50px">
              {{ item.size }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 60px">
              {{ item.quantity }}{{ item.unit }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 80px">
              {{ item.price | currency }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 80px">
              {{ (item.quantity * item.price) | currency }}
            </td>
            <td style="border: 1px solid #dfe5ec; width: 100px">
              <raw-html :content="item.remark"></raw-html>
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec; text-align: left">
            <td style="border: 1px solid #dfe5ec; padding: 5px" colspan="2">
              {{ $t("bargain.receivePaymentInfo") }}
            </td>
            <td style="border: 1px solid #dfe5ec; padding: 5px" colspan="8">
              {{ $t("bargain.ordersTotal") }}：{{
                printRent.amount | currency
              }}&nbsp;&nbsp; {{ $t("bargain.actualReceive") }}：{{
                printRent.payAmount | currency
              }}&nbsp;&nbsp;
              <span v-if="printRent.differAmount < 0">
                {{ $t("bargain.differReceive") }}：{{
                  -printRent.differAmount | currency
                }}&nbsp;&nbsp;
              </span>
              <span v-if="printRent.differAmount > 0">
                {{ $t("bargain.leavePayAmount") }}：{{
                  printRent.differAmount | currency
                }}&nbsp;&nbsp;
              </span>
            </td>
          </tr>
          <tr style="border: 1px solid #dfe5ec; text-align: left">
            <td style="border: 1px solid #dfe5ec; padding: 5px" colspan="2">
              {{ $t("text.remark") }}
            </td>
            <td style="border: 1px solid #dfe5ec; padding: 5px" colspan="8">
              <raw-html :content="printRent.remark"></raw-html>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- 打印自定义租赁单 -->
    <div id="printRentSlipCustomDiv" style="display: none">
      <div id="customPrintContentRentSlip" />
    </div>

    <drawer
      :title="$t('text.edit', [$t('menu.rents')])"
      :visible.sync="editRentItemDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <edit-rent-item
        :id="currentRowRentItemId"
        @updateInfo="rentItemUpdated"
      />
    </drawer>
    <!-- ===== -->

    <!-- 出库 -->
    <el-dialog
      :title="$t('action.stockOut')"
      :close-on-click-modal="false"
      :visible.sync="outDF"
      width="30%"
    >
      <el-form ref="outObjForm" :model="outObj" label-width="60px">
        <el-form-item
          :prop="'shelfId'"
          :label="$t('menu.shelfs')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('menu.shelfs')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select size="small" v-model="outObj.shelfId" filterable clearable>
            <el-option
              v-for="item of rowInventoryShelfs"
              :key="item.shelfId"
              :label="item.text"
              :value="item.shelfId"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="outDoing"
          size="small"
          @click="outSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="outDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 入库 -->
    <el-dialog
      :title="$t('action.stockIn')"
      :close-on-click-modal="false"
      :visible.sync="finishItemDF"
      width="30%"
    >
      <el-form
        ref="finishItemObjForm"
        :model="finishItemObj"
        label-width="60px"
      >
        <el-form-item
          :prop="'shelfId'"
          :label="$t('menu.shelfs')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('menu.shelfs')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="finishItemObj.shelfId"
            filterable
            clearable
          >
            <el-option
              v-for="item of rowShopShelfs"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="finishItemDoing"
          size="small"
          @click="finishItemSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="finishItemDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import ls from "store2";
import { countriesCN } from "@/utils/enums.js";
import { table, page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";

import DateRange from "@/components/DateRange";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import RawHtml from "@/components/RawHtml";

import Dropzone from "@/components/Dropzone";

import ShowRent from "./showRent";
import EditRent from "./editRent";
import EditRentItem from "./editRentItem";

//
import Rent from "@/api/rent.js";
import RentItem from "@/api/rentItem.js";

import Shop from "@/api/shop.js";
import User from "@/api/user.js";
import PayMethod from "@/api/payMethod.js";
import Customer from "@/api/customer.js";
import Payment from "@/api/payment.js";
import PrintTemplate from "@/api/printTemplate.js";
import Inventory from "@/api/inventory.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    RawHtmlLimitNumber,
    RawHtml,
    Dropzone,
    ShowRent,
    EditRent,
    EditRentItem,
  },

  data() {
    return {
      Util: Util,
      countriesCN: countriesCN,
      sorter: {
        sortBy: "rents_id",
        sortIndicator: "desc",
      },
      narrows: [
        [
          {
            label: this.$t("text.workflowState"),
            items: RentItem.states_all.map((s) => {
              return {
                key: s,
                label: this.$t("rentStates." + s),
                condition: { workflowState: s },
              };
            }),
          },
          {
            label: this.$t("text.type"),
            items: [
              {
                key: "rent",
                label: this.$t("menu.rents"),
                condition: { type: "rent" },
              },
              {
                key: "clean",
                label: this.$t("menu.cleans"),
                condition: { type: "clean" },
              },
            ],
          },
        ],
      ],
      initFilter: null,
      searchForm: {
        keyword: null,
        productNo: null,
        rentAtStartAt: null,
        rentAtEndAt: null,
        createAtStartAt: null,
        createAtEndAt: null,
        shopId: null,
        remark: null,
      },

      shops: [],
      //
      currentRowIdx: null,
      currentRowRentId: null,
      currentRowRentItemId: null,

      showRentDF: false,
      editRentDF: false,
      editRentItemDF: false,
      // 分配拥有人
      distributiveOwnerDF: false,
      distributiveOwnerObj: {
        uuid: null,
        ownerId: null,
        ownerName: null,
      },
      usersFilterValid: [],
      distributiveOwnerDoing: false,
      // 收款
      addPaymentDF: false,
      pickerOptionsFiveDays: {
        disabledDate(time) {
          const curDate = new Date().getTime();
          const day = 5 * 24 * 3600 * 1000;
          const threeMonths = curDate - day;
          return time.getTime() > Date.now() || time.getTime() < threeMonths;
        },
      },
      payMethods: [],
      customer: null,
      addPaymentObj: {
        type: "receivables", // return
        total: null,
        payMethodId: null,
        payMethodName: null,
        explain: null,
        currency: "CNY",
        rentId: null,
        paidAt: null,
        voucher: null,
        settlementId: 0, // 先付款
        customerId: null,
      },
      addPaymentDoing: false,
      //
      printTemplatesRentSlip: [],
      printRent: { shopName: null },
      customPrintContent: "",

      // 出库
      outDF: false,
      row: false,
      outObj: {
        shelfId: null,
        inventoryId: null,
      },
      rowInventoryShelfs: [],
      outDoing: false,
      // 入库
      finishItemDF: false,
      finishItemObj: {
        shelfId: null,
      },
      rowShopShelfs: [],
      finishItemDoing: false,
    };
  },
  created() {
    const self = this;
    axios
      .all([
        User.findByTenantId(self.Permit.currentTenant().id),
        Shop.findByTenantId(),
        PrintTemplate.findByType({ type: "rentSlip" }),
      ])
      .then(
        axios.spread(function (users, shops, printTemplatesRentSlip) {
          if (users.status === 200) {
            self.users = users.data.filter((u) => u.authorize === true);
          } else {
            self.sysError();
          }
          if (shops.status === 200) {
            self.shops = shops.data;
          } else {
            self.sysError();
          }
          if (printTemplatesRentSlip.status === 200) {
            self.printTemplatesRentSlip = printTemplatesRentSlip.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    // 下载
    download(type) {
      const self = this;
      if (type === "search") {
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        Vue.set(data, "excelType", "general");
        self.downloadData(data);
      }
      if (type == "checked") {
        if (!self.downloadChecked(self.selectedBargains())) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: self.selectedBargains().map((c) => c.id),
          excelType: "general",
        };
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      Rent.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    // 入库
    finishItem(row, rowIndex) {
      const self = this;
      self.row = row;
      self.currentRowIdx = rowIndex;
      const obj = self.shops.find((shop) => shop.id == row._rent.shopId);
      if (obj != null) {
        self.rowShopShelfs = obj.shelfs;
        self.finishItemDoing = false;
        self.finishItemDF = true;
      }
    },
    finishItemSubmit() {
      const self = this;
      self.$refs.finishItemObjForm.validate((valid) => {
        if (valid) {
          self.finishItemDoing = true;
          RentItem.finish(self.row.id, self.finishItemObj).then(function (res) {
            self.finishItemDoing = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.stockInSuccess"),
                type: "success",
              });
              self.finishItemDF = false;
              self.records[self.currentRowIdx].workflowState = "finished";
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 出库
    outItem(row, rowIndex) {
      const self = this;
      self.row = row;
      self.currentRowIdx = rowIndex;
      const obj = {
        shopId: row._rent.shopId,
        productNo: row.productNo,
        color: row.color,
        size: row.size,
      };
      Inventory.findByProductInfo(obj).then(function (res) {
        if (res.data.code === 200) {
          const invInfo = res.data.entity;
          if (invInfo.quantity - invInfo.totalLock < row.quantity) {
            self.$message({
              message:
                self.$t("prompt.invQtyNotEnough") +
                invInfo.quantity +
                "，锁定量：" +
                invInfo.totalLock,
              type: "warning",
            });
            return;
          }
          self.outObj.inventoryId = invInfo.id;
          self.rowInventoryShelfs = invInfo.inventoryShelfs;
          for (const shelf of self.rowInventoryShelfs) {
            Vue.set(
              shelf,
              "text",
              shelf.shelfName + "(数量:" + shelf.quantity + ")"
            );
          }
          self.outDoing = false;
          self.outDF = true;
        } else {
          self.$message({
            message: self.$t("inventory.inventoryInfoNoExist"),
            type: "warning",
          });
        }
      });
    },
    outSubmit() {
      const self = this;
      self.$refs.outObjForm.validate((valid) => {
        if (valid) {
          const obj = self.rowInventoryShelfs.find(
            (shelf) => shelf.shelfId == self.outObj.shelfId
          );
          if (self.row.quantity > obj.quantity) {
            self.$message({
              message: self.$t("prompt.invQtyNotEnough"),
              type: "warning",
            });
            return;
          }
          self.outDoing = true;
          RentItem.out(self.row.id, self.outObj).then(function (res) {
            self.outDoing = false;
            if (res.status === 200) {
              self.sysResult(res.data);
              self.loadData();
              self.outDF = false;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 删除子订单
    deleteItem(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        RentItem.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    editRentItem(row, rowIndex) {
      this.currentRowRentItemId = row.id;
      this.currentRowIdx = rowIndex;
      this.editRentItemDF = true;
    },
    rentItemUpdated(rentItem) {
      for (const key in this.records[this.currentRowIdx]) {
        this.records[this.currentRowIdx][key] = rentItem[key];
      }
      this.editRentItemDF = false;
    },
    // 打印客户清单
    printRentSlip(row, cmd) {
      const self = this;
      self.printRent = row;
      if (cmd === "printRentSlipDiv") {
        self.$nextTick(function () {
          self.print(cmd);
        });
      } else {
        self.$nextTick(function () {
          self.customPrintSubmit(cmd);
        });
      }
    },
    print(type) {
      this.printFunction(type);
    },
    customPrintSubmit(cmd) {
      const self = this;
      // console.log("===", cmd);
      self.customPrintContent = cmd.content;
      let currencySymbol = "¥";
      self.customPrintContent = self.customPrintContent.replace(
        /\${租赁单号}/g,
        self.printRent.serialNo
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${租赁额}/g,
        currencySymbol + self.printRent.amount
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${收款额}/g,
        currencySymbol + self.printRent.payAmount
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${欠款额}/g,
        currencySymbol + self.printRent.differAmount
      );
      if (self.printRent.payments.length != null) {
        let paymentsInfo = "";
        if (self.printRent.payments.length === 1) {
          paymentsInfo =
            self.printRent.payments[0].payMethodName +
            "(" +
            currencySymbol +
            self.printRent.payments[0].total +
            ") ";
        } else {
          for (const paymentIdx in self.printRent.payments) {
            const sequence = parseInt(paymentIdx) + 1;
            paymentsInfo =
              paymentsInfo +
              sequence +
              "." +
              self.printRent.payments[paymentIdx].payMethodName +
              "(" +
              currencySymbol +
              self.printRent.payments[paymentIdx].total +
              ") ";
          }
        }
        self.customPrintContent = self.customPrintContent.replace(
          /\${收款方式}/g,
          paymentsInfo
        );
      }
      self.customPrintContent = self.customPrintContent.replace(
        /\${创建日期}/g,
        self.printRent.createAt
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${开始日期}/g,
        self.printRent.startAt
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${结束日期}/g,
        self.printRent.endAt
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${销售}/g,
        self.printRent.ownerName
      );
      let remark = "";
      if (self.printRent.remark != null) {
        remark = self.printRent.remark.replace(
          /<p>/g,
          "<p style='margin: 0; padding: 0'>"
        );
      }
      self.customPrintContent = self.customPrintContent.replace(
        /\${租赁单备注}/g,
        remark
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${客户姓名}/g,
        self.printRent.customerName
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${客户电话}/g,
        self.printRent.customerPhone
      );
      if (self.printRent.customerCountry != null) {
        self.customPrintContent = self.customPrintContent.replace(
          /\${客户国家}/g,
          countriesCN[self.printRent.customerCountry]
        );
      } else {
        self.customPrintContent = self.customPrintContent.replace(
          /\${客户国家}/g,
          ""
        );
      }

      self.customPrintContent = self.customPrintContent.replace(
        /\${客户省份}/g,
        self.printRent.customerProvince || ""
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${客户城市}/g,
        self.printRent.customerCity || ""
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${客户地址}/g,
        self.printRent.customerAddress || ""
      );
      self.customPrintContent = self.customPrintContent.replace(
        /\${客户邮编}/g,
        self.printRent.customerZipcode || ""
      );
      if (self.printRent.rentItems && self.printRent.rentItems.length !== 0) {
        self.customPrintContent = self.customPrintContent.replace(
          /\${图片}/g,
          "<image src='" +
            self.printRent.rentItems[0].firstImage +
            "' style='width: 260px'/>"
        );

        const rentItemContentTitle =
          "<table style='width: 100%; border-collapse:collapse; border: 1px solid black; text-align: left; margin-bottom: 20px; padding: 5px'>" +
          "<tr style='border: 1px solid black;  text-align: center'>" +
          "<td style='border: 1px solid black; width: 60px;'>序号</td>" +
          "<td style='border: 1px solid black; '>租赁单项号</td>" +
          "<td style='border: 1px solid black; width: 100px;'>品牌</td>" +
          "<td style='border: 1px solid black; width: 100px;'>分类</td>" +
          "<td style='border: 1px solid black; '>货号</td>" +
          "<td style='border: 1px solid black; width: 100px;'>颜色</td>" +
          "<td style='border: 1px solid black; width: 60px;'>规格</td>" +
          "<td style='border: 1px solid black; width: 80px;'>数量</td>" +
          "<td style='border: 1px solid black; width: 80px;'>价格</td>" +
          "<td style='border: 1px solid black; width: 100px; '>小计</td>" +
          "</tr>";
        let rentItemContents = "";

        const rentItemrContentTitle2 =
          "<table style='width: 100%; border-collapse:collapse; border: 1px solid black; text-align: left; margin-bottom: 20px; padding: 5px'>" +
          "<tr style='border: 1px solid black;  text-align: center'>" +
          "<td style='border: 1px solid black; width: 60px;'>序号</td>" +
          "<td style='border: 1px solid black; '>货号</td>" +
          "<td style='border: 1px solid black; width: 100px;'>颜色</td>" +
          "<td style='border: 1px solid black; width: 80px;'>规格</td>" +
          "<td style='border: 1px solid black; width: 80px;'>数量</td>" +
          "<td style='border: 1px solid black; width: 80px;'>租赁单价</td>" +
          "<td style='border: 1px solid black; width: 100px; '>小计</td>" +
          "</tr>";
        let rentItemrContents2 = "";

        for (const rentItemIndex in self.printRent.rentItems) {
          const rentItemSequence = parseInt(rentItemIndex) + 1;
          let rentItemRemark = "";
          if (self.printRent.rentItems[rentItemIndex].remark != null) {
            rentItemRemark = self.printRent.rentItems[
              rentItemIndex
            ].remark.replace(/<p>/g, "<p style='margin: 0; padding: 0'>");
          }
          const subTotal = Util.toFixed(
            self.printRent.rentItems[rentItemIndex].price *
              self.printRent.rentItems[rentItemIndex].quantity,
            3
          );
          // ====1
          let rentItemContent =
            "<tr style='border: 1px solid black;  text-align: center'>" +
            "<td style='border: 1px solid black;'>" +
            rentItemSequence +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            self.printRent.rentItems[rentItemIndex].serialNo +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printRent.rentItems[rentItemIndex].productBrand || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printRent.rentItems[rentItemIndex].categoryName || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            self.printRent.rentItems[rentItemIndex].productNo +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            (self.printRent.rentItems[rentItemIndex].color || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printRent.rentItems[rentItemIndex].size || "") +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            self.printRent.rentItems[rentItemIndex].quantity +
            (self.printRent.rentItems[rentItemIndex].unit || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            currencySymbol +
            self.printRent.rentItems[rentItemIndex].price +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            currencySymbol +
            subTotal +
            "</td>" +
            "</tr>";
          if (rentItemRemark !== "") {
            rentItemContent =
              rentItemContent +
              "<tr v-if='' style='border: 1px solid black;'>" +
              "<td style='border: 1px solid black; text-align: center'>备注:</td>" +
              "<td colspan='14' style='border: 1px solid black;; text-align: left'>" +
              rentItemRemark +
              "</td>" +
              "</tr></table>";
          } else {
            rentItemContent = rentItemContent + "</table>";
          }
          rentItemContents = rentItemContents + rentItemContent;
          // =====2
          let rentItemContent2 =
            "<tr style='border: 1px solid black;  text-align: center'>" +
            "<td style='border: 1px solid black;'>" +
            rentItemSequence +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            self.printRent.rentItems[rentItemIndex].productNo +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            (self.printRent.rentItems[rentItemIndex].color || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            (self.printRent.rentItems[rentItemIndex].size || "") +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            self.printRent.rentItems[rentItemIndex].quantity +
            (self.printRent.rentItems[rentItemIndex].unit || "") +
            "</td>" +
            "<td style='border: 1px solid black;'>" +
            currencySymbol +
            self.printRent.rentItems[rentItemIndex].price +
            "</td>" +
            "<td style='border: 1px solid black; '>" +
            currencySymbol +
            subTotal +
            "</td>" +
            "</tr>";
          if (rentItemRemark !== "") {
            rentItemContent2 =
              rentItemContent2 +
              "<tr v-if='' style='border: 1px solid black;'>" +
              "<td style='border: 1px solid black; text-align: center'>备注:</td>" +
              "<td colspan='14' style='border: 1px solid black;; text-align: left'>" +
              rentItemRemark +
              "</td>" +
              "</tr></table>";
          } else {
            rentItemContent2 = rentItemContent2 + "</table>";
          }
          rentItemrContents2 = rentItemrContents2 + rentItemContent2;
        }
        self.customPrintContent = self.customPrintContent.replace(
          /\${租赁单项}/g,
          rentItemContentTitle + rentItemContents
        );
        self.customPrintContent = self.customPrintContent.replace(
          /\${精简租赁单项}/g,
          rentItemrContentTitle2 + rentItemrContents2
        );
      } else {
        self.customPrintContent = self.customPrintContent.replace(
          /\${图片}/g,
          ""
        );
        self.customPrintContent = self.customPrintContent.replace(
          /\${租赁单项}/g,
          ""
        );
        self.customPrintContent = self.customPrintContent.replace(
          /\${精简租赁单项}/g,
          ""
        );
      }
      window.document.getElementById("customPrintContentRentSlip").innerHTML =
        self.customPrintContent;
      self.print("printRentSlipCustomDiv");
    },

    // 添加收款
    addPayment(row, index) {
      const self = this;
      self.currentRowIdx = index;
      self.addPaymentObj.rentId = row.id;
      self.addPaymentObj.paidAt = Util.formatDate(new Date());
      self.addPaymentObj.total = null;
      self.addPaymentObj.explain = null;
      self.addPaymentObj.voucher = null;
      self.addPaymentObj.type = "receivables";
      self.addPaymentObj.customerId = row.customerId;
      axios
        .all([
          PayMethod.findByTypes({ types: PayMethod.saleTypes }),
          Customer.findById(row.customerId),
        ])
        .then(
          axios.spread(function (payMethods, customers) {
            if (payMethods.status === 200) {
              self.payMethods = payMethods.data;
            } else {
              self.sysError();
            }
            if (customers.data.code === 200) {
              self.customer = customers.data.entity;
              if (self.customer != null) {
                self.payMethods.push({
                  id: -1,
                  name: "账户余额(¥" + self.customer.balance + ")",
                });
              }
            } else {
              self.customer = null;
            }
            self.addPaymentDoing = false;
            self.addPaymentDF = true;
          })
        );
    },
    blurJudgeBalance() {
      const self = this;
      if (
        self.customer != null &&
        self.addPaymentObj.payMethodId === -1 &&
        self.addPaymentObj.type === "receivables" &&
        self.addPaymentObj.total > self.customer.balance
      ) {
        self.addPaymentObj.payMethodId = null;
        self.$message({
          message: self.$t("prompt.customerBalanceNotEnougth"),
          type: "warning",
        });
      }
    },
    addPaymentSubmit() {
      const self = this;
      self.$refs.addPaymentObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.addPaymentObj.total)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("payment.total")]),
              type: "warning",
            });
            return;
          }
          if (self.addPaymentObj.type === "return") {
            self.addPaymentObj.total = -self.addPaymentObj.total;
          }
          self.addPaymentObj.payMethodName = self.payMethods.find(
            (p) => p.id === self.addPaymentObj.payMethodId
          ).name;
          self.addPaymentObj.paidAt = Util.formatDate(
            self.addPaymentObj.paidAt
          );
          self.addPaymentDoing = true;
          Payment.create(self.addPaymentObj).then(function (res) {
            if (res.data.code === 201) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.records[self.currentRowIdx].payAmount =
                self.records[self.currentRowIdx].payAmount +
                Number(self.addPaymentObj.total);
              self.records[self.currentRowIdx].differAmount =
                self.records[self.currentRowIdx].differAmount -
                Number(self.addPaymentObj.total);
            } else {
              self.sysError();
            }
            self.addPaymentDoing = false;
            self.addPaymentDF = false;
          });
        } else {
          return false;
        }
      });
    },

    // 分配拥有人
    distributiveOwner(row, index) {
      const self = this;
      self.currentRowIdx = index;
      self.distributiveOwnerObj.id = row.id;
      self.usersFilterValid = self.users.filter((u) => u.voidAt == null);
      if (self.users.find((u) => u.id === row.ownerId) != null) {
        self.distributiveOwnerObj.ownerId = row.ownerId;
      }
      self.distributiveOwnerDoing = false;
      self.distributiveOwnerDF = true;
    },
    distributiveOwnerSubmit() {
      const self = this;
      self.$refs.distributiveOwnerObjForm.validate((valid) => {
        if (valid) {
          self.distributiveOwnerObj.ownerName = self.users.find(
            (u) => u.id === self.distributiveOwnerObj.ownerId
          ).name;
          self.distributiveOwnerDoing = true;
          Rent.updataOwner(self.distributiveOwnerObj).then(function (res) {
            self.distributiveOwnerDoing = false;
            self.distributiveOwnerDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.distributiveSuccess"),
                type: "success",
              });
              self.records[self.currentRowIdx].ownerName =
                self.distributiveOwnerObj.ownerName;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    //删除
    canDelRent(row) {
      if (row.rentItems && row.rentItems.length !== 0) {
        return false;
      } else {
        return true;
      }
    },
    deleteRent(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Rent.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },

    //编辑
    canEditRent(row) {
      if (row.rentItems && row.rentItems.length !== 0) {
        const canEditRentItems = row.rentItems.filter(
          (item) => item.workflowState === "newly"
        );
        if (canEditRentItems.length === row.rentItems.length) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    },
    editRent(row, rowIndex) {
      this.currentRowRentId = row.id;
      this.currentRowIdx = rowIndex;
      this.editRentDF = true;
    },
    rentUpdated(rent) {
      this.records[this.currentRowIdx].serialNo = rent.serialNo;
      this.records[this.currentRowIdx].remark = rent.remark;
      this.records[this.currentRowIdx].startAt = rent.startAt;
      this.records[this.currentRowIdx].endAt = rent.endAt;
      this.records[this.currentRowIdx].shopId = rent.shopId;
      this.records[this.currentRowIdx].shopName = rent.shopName;
      this.editRentDF = false;
    },

    //===
    showRent(row) {
      this.currentRowRentId = row.id;
      this.showRentDF = true;
    },
    showRentUpdated() {
      this.loadData();
    },
    //
    dataProvider(params) {
      return Rent.search(params);
    },
    recordsDecorate(records) {
      this.records = this.buildTableData(records);
      this.mergeCells = this.buildMergeCells(records);
    },
    buildTableData(records) {
      let rs = [];
      records.forEach((record) => {
        let bRent = {
          isMerge: true,
          id: record.id,
          serialNo: record.serialNo,
          customerId: record.customerId,
          customerName: record.customerName,
          customerCountry: record.customerCountry,
          customerProvince: record.customerProvince,
          customerCity: record.customerCity,
          customerAddress: record.customerAddress,
          customerPhone: record.customerPhone,
          customerZipcode: record.customerZipcode,
          remark: record.remark,
          cancelAt: record.cancelAt,
          cancelReason: record.cancelReason,
          ownerId: record.ownerId,
          ownerName: record.ownerName,
          shopId: record.shopId,
          shopName: record.shopName,
          createAt: record.createAt,
          tenantId: record.tenantId,
          startAt: record.startAt,
          endAt: record.endAt,
          customerSource: record.customerSource,
          amount: record.amount,
          payAmount: record.payAmount,
          differAmount: record.differAmount,
          rentItems: record.rentItems,
          payments: record.payments,
          type: record.type,
        };
        rs.push(bRent); //将bargain的数据转换到格式，放到数据列表
        // record.rentItems.forEach((item) => {
        //   rs.push(item);
        // });
        for (const item of record.rentItems) {
          Vue.set(item, "_rent", bRent);
          rs.push(item);
        }
      });
      return rs;
    },
    buildMergeCells(rents) {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < rents.length; i++) {
        mcs.push({ row: rowIdx, col: 1, rowspan: 1, colspan: 9 });
        rowIdx = rowIdx + rents[i].rentItems.length + 1;
      }
      return mcs;
    },
    calculateBgColor({ row, rowIndex }) {
      return row.isMerge
        ? "light-blue-bg"
        : this.rowBgColor({ row: row, rowIndex: rowIndex });
    },

    selectedBargains() {
      // console.log("=====selectedBargains:");
      return this.$refs.recordsTable
        .getCheckboxRecords()
        .filter((r) => r.isMerge);
    },
    selectedOrders() {
      // console.log("=====selectedOrders:");
      return this.$refs.recordsTable
        .getCheckboxRecords()
        .filter((r) => !r.isMerge);
    },
    selectRecord({ rowIndex, selection, checked, row, data }) {
      // console.log("====selectRecord");
      if (row.isMerge) {
        let orders = data.filter((r) => r.bargainId == row.id);
        this.$refs.recordsTable.setCheckboxRow(orders, checked);
      }
      this.setSelectedQty();
    },
    selectAllRecords() {
      // console.log("=====selectAllRecords");
      this.setSelectedQty();
    },
  },
};
</script>
<style scoped>
.group {
  float: left;
  margin-left: 10px;
  border: 1px solid rgba(64, 158, 255, 0.2);
  color: #409eff;
  background: rgba(64, 158, 255, 0.1);
  padding: 0px 4px;
  border-radius: 3px;
  font-size: 12px;
}
.tag-type {
  float: left;
  margin-bottom: 1px;
  margin-left: 1px;
  padding: 0 1px;
  font-size: 12px;
  border-radius: 4px;
}
</style>